const CORE_ETR_ACTIVATION_MAP = {
  honda: { civic: { 2026: { hybrid: true } } },
  tesla: { 'model-3': { 2026: { sedan: true } } },
  hyundai: { palisade: { 2026: { hybrid: true } }, 'ioniq-5': { 2026: { suv: true } } },
  ford: { maverick: { 2026: { supercrew: true } } },
  rivian: { r1t: { 2026: { 'crew-cab': true } } },
};

export const isCoreEtrActivationEnabled = (make, model, year, submodel) =>
  !!CORE_ETR_ACTIVATION_MAP[make]?.[model]?.[year]?.[submodel];
